import React from 'react';
import styles from './Button.module.css';

/**
 * Button Component
 * Variants: primary, secondary, ghost, danger
 * Sizes: sm, md, lg
 */
const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    disabled = false,
    loading = false,
    icon,
    iconRight,
    type = 'button',
    className = '',
    ...props
}) => {
    const classNames = [
        styles.button,
        styles[variant],
        styles[size],
        fullWidth && styles.fullWidth,
        loading && styles.loading,
        className
    ].filter(Boolean).join(' ');

    return (
        <button
            type={type}
            className={classNames}
            disabled={disabled || loading}
            {...props}
        >
            {loading && (
                <span className={styles.spinner} aria-hidden="true">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeDasharray="10 25" />
                    </svg>
                </span>
            )}
            {!loading && icon && <span className={styles.iconLeft}>{icon}</span>}
            <span className={styles.label}>{children}</span>
            {!loading && iconRight && <span className={styles.iconRight}>{iconRight}</span>}
        </button>
    );
};

export default Button;
